import {
    DEALERCHANGEDSRMASTERPASSWORD_SUCCESS,
    DEALERCHANGEDSRMASTERPASSWORD_FAILED,
    RESET_DEALERCHANGEDSRMASTERPASSWORD,
    LOADING_DEALERCHANGEDSRMASTERPASSWORD,
    NETWORK_ERROR_DEALERCHANGEDSRMASTERPASSWORD
} from '../types/index'
const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERCHANGEDSRMASTERPASSWORD:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERCHANGEDSRMASTERPASSWORD_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERCHANGEDSRMASTERPASSWORD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERCHANGEDSRMASTERPASSWORD:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERCHANGEDSRMASTERPASSWORD:
            return (state = initialState);
        default:
            return state;
    }
};